// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = () => ({
  screenTitle: {
    margin: '16px 0 0 0',
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px 20px 32px 20px',
  },
  row: {
    width: '100%',
    maxWidth: 420,
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
  },
  // Every colour here is explicit. Inside the account panel an unset colour
  // inherits white and the text disappears - which is exactly what happened
  // to the amount label on the issue-voucher screen.
  input: {
    flex: 1,
    height: 40,
    padding: '0 12px',
    border: '1px solid #cacaca',
    borderRadius: 4,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
  },
  help: {
    width: '100%',
    maxWidth: 420,
    margin: '4px 0 0 0',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  voucherPanel: {
    width: '100%',
    maxWidth: 420,
    marginTop: 20,
    padding: 16,
    borderRadius: 8,
    border: '1px solid #E5E5E5',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginTop: 6,
  },
  detailLabel: {
    margin: 0,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  detailValue: {
    margin: 0,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  balanceValue: {
    margin: 0,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    color: GlobalStyles.color.COLOR_GREY,
  },
  message: {
    width: '100%',
    maxWidth: 420,
    marginTop: 16,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
  },
  error: {
    color: '#ff4a75',
  },
  success: {
    color: GlobalStyles.color.COLOR_GREEN,
  },
  buttonWrapper: {
    marginTop: 20,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
  },
  arrowBackContainer: {
    margin: '5px 0 0',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  link: {
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
  historyLink: {
    display: 'block',
    marginTop: 12,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_SECONDARY,
    textAlign: 'right',
  },
});

export default styles;
